import { render } from "./MyWallets.vue?vue&type=template&id=1ace343a&scoped=true"
import script from "./MyWallets.vue?vue&type=script&lang=js"
export * from "./MyWallets.vue?vue&type=script&lang=js"

import "./MyWallets.vue?vue&type=style&index=0&id=1ace343a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ace343a"]])

export default __exports__